import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";

const stats = [
  { key: "minutes", label: "Meeting Minutes", path: "/minutes" },
  { key: "events", label: "Upcoming Events", path: "/events" },
  { key: "notices", label: "Information Notices", path: "/notices" },
  { key: "officials", label: "Board Members", path: "/officials" },
  { key: "projects", label: "Projects", path: "/projects" },
  { key: "links", label: "Helpful Links", path: "/links" },
];

const AdminOverview = () => {
  const [counts, setCounts] = useState({});

  useEffect(() => {
    Promise.all(stats.map((s) => api.get(s.path).then((r) => [s.key, r.data.length]).catch(() => [s.key, 0])))
      .then((pairs) => setCounts(Object.fromEntries(pairs)));
  }, []);

  return (
    <div data-testid="admin-overview">
      <h1 className="font-heading text-3xl font-semibold tracking-tight">Welcome back</h1>
      <p className="text-muted-foreground mt-1">Quick view of your township website content.</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mt-8">
        {stats.map((s) => (
          <Card key={s.key} className="border-border" data-testid={`overview-card-${s.key}`}>
            <CardContent className="p-6">
              <div className="text-xs uppercase tracking-[0.18em] text-secondary">{s.label}</div>
              <div className="font-heading text-4xl font-semibold mt-2 text-primary">{counts[s.key] ?? "—"}</div>
            </CardContent>
          </Card>
        ))}
      </div>

      <div className="mt-10 p-6 rounded-xl bg-white border border-border">
        <div className="text-xs uppercase tracking-[0.2em] text-accent mb-2">Getting started</div>
        <h2 className="font-heading text-xl font-semibold">Edit your site with the menu on the left</h2>
        <p className="text-sm text-muted-foreground mt-2 leading-relaxed">
          Add or update banner alerts, post new meeting minutes, schedule meetings, manage officials, post notices, and reply to visitors in the live chat inbox.
        </p>
      </div>
    </div>
  );
};

export default AdminOverview;
